<template>
  <section class="safety-profile">
    <div class="contents mx-auto">
      <b-container>
        <b-row>
          <b-col>
            <div class="text-center">
              <h2 class="mb-0">JORNAY PM has a demonstrated safety profile.</h2>

              <p class="fw-extrabold text-black-90 mt-0">
                But what does that mean? It means JORNAY PM is:
              </p>

              <div class="boxes">
                <div class="boxes__item">
                  <img
                    src="@/assets/images/3_25/safety/doctor.webp"
                    width="67"
                    height="80"
                    alt="Blue icon of a doctor"
                  />
                  <p class="text-black mb-0">
                    Formulated with a medicine—methylphenidate—that has been
                    prescribed for decades
                  </p>
                </div>
                <div class="boxes__item">
                  <img
                    src="@/assets/images/3_25/safety/medicine.webp"
                    width="61"
                    height="61"
                    alt="Blue icon of a JORNAY PM capsule"
                  />
                  <p class="text-black mb-0">
                    Found to have similar
                    <br class="d-none d-lg-block" />side&nbsp;effects as other
                    methylphenidate medicines
                  </p>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </section>
</template>

<script>
export default {
  name: "SafetProfile",
};
</script>
